var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"disabled":_vm.disabled,"label":_vm.label,"hide-details":""},model:{value:(_vm.property),callback:function ($$v) {_vm.property=$$v},expression:"property"}})}
var staticRenderFns = []

export { render, staticRenderFns }